module.exports = __webpack_public_path__ + "img/vertical_7_5_8019.d1565d78.png";